export const navigateTo = (link: string) => {
  window.location.href = link;
};

export function refreshPage() {
  window.location.reload();
}

export function reloadPage() {
  window.location.reload(); // force reload from server
}

export const openNewTab = (link: string | null | undefined) => {
  if (link) {
    // Open the link in a new tab
    window.open(link, "_blank", "noopener,noreferrer");
  } else {
    console.error("No link provided");
  }
};
